import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';
import { Context } from '../context';



// This function takes a component...

export const withVersion = Component => ({ ...props }) => {
  const context = useContext(Context);

  return (<Component toggle={context['toggle']} {...props} />)
};

export const VersionToggle = () => {
  const context = useContext(Context);
  return (<CSSutility
    onClick={() => {
      context.handles['setVersion'](!context.version)
    }}
  >
    {context.version && <span>dev</span>}
    {!context.version && <span>prod</span>}
  </CSSutility>)
}

const CSSutility = styled.div`
  cursor: pointer;
  position: fixed;
  bottom: 4px;
  left: 4px;
  width: 64px;
  font-size: 10px;
  text-align: center;
  z-index: 1000000;
  display: flex;
  justify-content: center;
`;
